<template>
  <div>
    <CommonSites></CommonSites>
    <MoreSites></MoreSites>
  </div>
</template>

<script>
import CommonSites from './CommonSites.vue'
import MoreSites from './MoreSites.vue'

export default {
  name: "HomeDetailHome",
  components: {
    CommonSites,
    MoreSites
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HomeDetailHome.vue